import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useParams } from 'react-router-dom';
import { AmDonutChart3D } from 'components/amcharts/donutChart';
import { getOrgUserChart } from 'service/ChartService';
import { strings } from 'i18n/Strings';
import { useDispatch } from 'react-redux';
import { getOrganizationDetailsOrgId } from 'service/EmployerService';
import { setOrganizationInfo } from 'store/employeeDetails';

interface ChartType {
  category: string;
  value: number;
}

const EmployerDashboard = (): JSX.Element => {
  const { orgId } = useParams();
  const dispatch = useDispatch();
  const [userChart, setUserChart] = useState<ChartType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const getEmployeeData = (): void => {
    setLoading(true);
    if (orgId) {
      getOrganizationDetailsOrgId(Number(orgId))
        .then((res) => {
          dispatch(setOrganizationInfo(res));
        })
        .catch((err: Error) => {
          console.log(err);
        });

      getOrgUserChart(parseInt(orgId, 10))
        .then((result) => {
          const { data } = result;
          if (data) {
            setUserChart([
              {
                category: strings.displayText.noOfRegisteredUser,
                value: data?.registeredUserCount || 0,
              },
              {
                category: strings.displayText.noOfUnRegisteredUser,
                value: data?.unRegisteredUserCount || 0,
              },
            ]);
          }
        })
        .catch((err: Error) => {
          throw err;
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    getEmployeeData();
  }, [orgId]);

  return (
    <Box>
      {!loading ? (
        <>
          <Grid
            direction="row"
            justifyContent="space-between"
            container
            columns={12.2}
            sx={{ display: 'flex', padding: 1 }}
          >
            <AmDonutChart3D
              id="user_chart1"
              data={userChart}
              height="500px"
              colors={['#B5DFC8', '#EEC033']}
            />
          </Grid>
        </>
      ) : null}
    </Box>
  );
};

export default EmployerDashboard;
